import BottomOverlay from "./BottomOverlay"
import TopHeaderOverlay from "./TopHeaderOverlay"

/* Protopia Ecosystem component */
export interface ILandingOverlayProps {
   
}
const LandingOverlay = (props: ILandingOverlayProps): JSX.Element => {

    return <div className='pe-landing-overlay-container'>
       <TopHeaderOverlay />
       <BottomOverlay />
    </div>
}
export default LandingOverlay